import * as Track from './amplitude-tracking';
import * as CEP from './amplitude-cep';

export default {
  Track,
  CEP,
};
